module.exports = __webpack_public_path__ + "static/media/AP.8426500d.svg";